// --- escapeForRegExp

export default function escapeForRegExp ( str ) {
    return str
        .replace(
            /[\^$\\.*+?()[\]{}|]/g,
            "\\$&"
        )
}
